import { type FormEvent, useState } from "react";
import { createHotel, getUsersApi, updateHotel } from "@praesto/core";
import { Modal, Button, Input, FormField } from "@praesto/ui-kit";

export function HotelModal(props: {
  initial?: {
    id?: string;
    name: string;
    city?: string;
    address?: string;
    phone?: string;
  };
  onClose: () => void;
  onDone: () => void;
}) {
  const [name, setName] = useState(props.initial?.name ?? "");
  const [city, setCity] = useState(props.initial?.city ?? "");
  const [address, setAddress] = useState(props.initial?.address ?? "");
  const [phone, setPhone] = useState(props.initial?.phone ?? "");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const api = getUsersApi();
      const tok = await api.getAuthToken();
      const body = {
        name,
        ...(city ? { city } : {}),
        ...(address ? { address } : {}),
        ...(phone ? { phone } : {}),
      };
      if (props.initial?.id) {
        await updateHotel(api.apiBase, props.initial.id, body, tok);
      } else {
        await createHotel(api.apiBase, body, tok);
      }
      props.onDone();
    } catch (e2) {
      setError(String(e2));
    } finally {
      setBusy(false);
    }
  }

  return (
    <Modal
      open
      onClose={props.onClose}
      title={props.initial?.id ? "Modifica hotel" : "Nuovo hotel"}
    >
      <form onSubmit={submit} className="space-y-3">
        <FormField label="Nome" required>
          <Input value={name} required onChange={(e) => setName(e.target.value)} />
        </FormField>
        <FormField label="Città">
          <Input value={city} onChange={(e) => setCity(e.target.value)} />
        </FormField>
        <FormField label="Indirizzo">
          <Input value={address} onChange={(e) => setAddress(e.target.value)} />
        </FormField>
        <FormField label="Telefono">
          <Input value={phone} onChange={(e) => setPhone(e.target.value)} />
        </FormField>
        <div className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
          <Button
            type="button"
            variant="ghost"
            className="w-full sm:w-auto"
            onClick={props.onClose}
          >
            Annulla
          </Button>
          <Button
            type="submit"
            variant="primary"
            className="w-full sm:w-auto"
            loading={busy}
            disabled={busy || !name}
          >
            Salva
          </Button>
        </div>
        {error && <p className="text-sm text-danger">{error}</p>}
      </form>
    </Modal>
  );
}
